
// ============================================
// 3. SERVICES WIDGET (ServicesWidget.jsx)
// ============================================
import React from 'react';

const services = [
    "Visa Application",
    "Ticketing",
    "Team Building",
    "Tours",
    "Safaris",
    "Conference Planning",
    "Hotel Reservation",
    "Airport Transfer",
    "Hotel Booking",
    "Safari Tours",
    "City Tour",
    "Car Rental",
    "Flight Booking",
    "Train Booking",
    "Cruise Booking",
    "Visa Assistance",
    "Travel Insurance",
    "Conference Services",
    "Wedding Planning",
    "Honeymoon Package",
    "Group Tours",
    "Corporate Travel"
];

const ServicesWidget = ({
    selectedServices = [],
    onServiceToggle,
    label = "Nature of Service (Select all that apply)",
    className = "",
    columns = 4,
    serviceList = services.sort()
}) => {
    return (
        <div className={`mb-3 ${className}`}>
            <label>{label}</label>
            <div className="row">
                {serviceList.map((service, i) => (
                    <div className={`col-md-${columns}`} key={i}>
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                value={service}
                                onChange={(e) => onServiceToggle(service, e.target.checked)}
                                checked={selectedServices.includes(service)}
                            />
                            <label className="form-check-label">{service}</label>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ServicesWidget;

